import { IGuiaTarifa } from "../../entities/guias/IGuiaTarifa";

export const SET_GUIA_TARIFA_LOADING = 'SET_GUIA_TARIFA_LOADING';
export const SET_GUIA_TARIFA_SUCCESS = 'SET_GUIA_TARIFA_SUCCESS';
export const SET_GUIA_TARIFA_ERROR = 'SET_GUIA_TARIFA_ERROR';
export const RESET_GUIA_TARIFA = 'RESET_GUIA_TARIFA';
export const MARK_GUIA_TARIFA_DIRTY = 'MARK_GUIA_TARIFA_DIRTY';

interface ISetGuiaTarifaLoading {
    type: typeof SET_GUIA_TARIFA_LOADING;
}

interface ISetGuiaTarifaSuccess {
    type: typeof SET_GUIA_TARIFA_SUCCESS;
    payload: Omit<IGuiaTarifa, 'status' | 'errorMessage' | 'dirty'>;
}

interface ISetGuiaTarifaError {
    type: typeof SET_GUIA_TARIFA_ERROR;
    errorMessage: string;
}

interface IResetGuiaTarifa {
    type: typeof RESET_GUIA_TARIFA;
}

interface IMarkGuiaTarifaDirty {
    type: typeof MARK_GUIA_TARIFA_DIRTY;
}

export type GuiaTarifaActionTypes =
    | ISetGuiaTarifaLoading
    | ISetGuiaTarifaSuccess
    | ISetGuiaTarifaError
    | IResetGuiaTarifa
    | IMarkGuiaTarifaDirty;
